import * as angular from "angular";
import {IController} from "angular";
import * as _ from 'lodash';
import {SplitService} from "../../../commons/services/split-service.service";
import {PlanningRouteModel} from "../../models/planning-route.model";

export class PlanningRoutesTotalsCtrl implements IController {

  selectedRoutes: PlanningRouteModel[];

  public totalRoutes: { length: number } = { length: 0 };
  public totals: {
    spots: number;
    packages: number;
    weight: number;
    volume: number;
    pallets: number;
  } = { spots: 0, packages: 0, weight: 0, volume: 0, pallets: 0 };

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this._updateTotals();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.selectedRoutes && !changes.selectedRoutes.isFirstChange()) {
      this._updateTotals();
    }
  }

  private _updateTotals() {
    this.totalRoutes = { length: this.selectedRoutes ? this.selectedRoutes.length : 0 };

    if (!this.selectedRoutes) {
      return;
    }

    this.totals = this.selectedRoutes.reduce((acc, route) => {
      acc.spots += route.totals.totalSpots || 0;
      acc.packages += route.totals.totalPackagesCount || 0;
      acc.weight += route.totals.totalLoad || 0;
      acc.volume += route.totals.totalVolume || 0;
      acc.pallets += route.totals.totalPallets || 0;
      return acc;
    }, { spots: 0, packages: 0, weight: 0, volume: 0, pallets: 0 });
    this.totals.pallets = _.round(this.totals.pallets, 2);
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningRoutesTotals', {
    bindings: {
      selectedRoutes: '<?',
    },
    template: require('./planning-routes-totals.html').default,
    controller: PlanningRoutesTotalsCtrl
  });
